import { connect } from 'react-redux'
import get from 'lodash/get'

import { ListingsContent } from '../components/ListingsContent'
import {
  listingsLoadMore,
  listingsFilterCall,
  loadSavedFilterInfo,
  setTabDefaultFilters,
} from '../actions/listings'

import { setPhoneBookInfo } from '../reducers/phoneBookInfo'
import { updateActiveTabId } from '../reducers/listings'
import { setOverfilteredStatus } from '../reducers/flags'
import { updateSelectedFareBrandFilters } from '../reducers/filters/filterInfo/filterInfo'
import { translateSearchRequest } from '../util/translateSearchRequest'

const mapStateToProps = (state, ownProps) => {
  const activeTabId = get(state, 'activeTabId')
  const pclnBootstrapData = state.pclnBootstrapData
  const translatedRequest = translateSearchRequest(pclnBootstrapData?.searchRequest)

  const isPackageListing = pclnBootstrapData?.isPackageListings
  const isReshopExperience = pclnBootstrapData?.isReshopExperience
  const tripType = translatedRequest?.tripType
  const isSameDaySearch = translatedRequest?.travelDate === translatedRequest?.returnDate
  const isRecommendedFlightBannerEligible =
    !isPackageListing && !isReshopExperience && activeTabId === 1 && tripType === 'RT' && !isSameDaySearch

  return {
    activeTabId,
    airlines: get(state, 'airlines', {}),
    altDeals: get(state, 'listings.altDeals'),
    brandReference: get(state, 'brandReference', []),
    currentMobileFilter: get(state, 'uiToggles.currentMobileFilter', ''),
    disableLoadingOverlay: state.uiToggles.loadingOverlay,
    displayAds:
      ((pclnBootstrapData?.partner && pclnBootstrapData?.features?.whiteLabel?.adsEnabled) ||
        !pclnBootstrapData?.partner) &&
      get(state, 'uiToggles.displayAds', true),
    displayInfiniteScrollLoadMore: state.displayInfiniteScrollLoadMore,
    fetchedInitialListings: state.fetchedInitialListings,
    filterValues: state.filterInfo,
    hasExpressDeal: get(state, 'flags.hasExpressDeal'),
    history: ownProps.history,
    listings: state.listings,
    recommendedListings: state.recommendedListings,
    listingsHasErrored: state.listingsHasErrored,
    listingsIsLoading: state.listingsIsLoading,
    listingsLoadingMessage: state.listingsLoadingMessage,
    listingsMetaData: get(state, 'listingsMetaData', {}),
    pclnBootstrapData,
    SETI: get(state, 'pclnBootstrapData.requestLocals.seti', []),
    slices: get(state, 'listings.response.rawResponse.slice'),
    attributeFilterConditions: ownProps.attributeFilterConditions,
    airSearchRequestModel: state?.airSearchRequestModel,
    flySearchResponseData: state?.flySearchResponseData,
    isFiltersAppliedForGa: state?.flags?.isFiltersAppliedForGa,
    isRecPackageVariant: ownProps.isRecPackageVariant,
    sortOptions: state?.sortOptions,
    translatedRequest,
    isRecommendedFlightBannerEligible,
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadSavedFilterInfo: ({ tabId }) => dispatch(loadSavedFilterInfo({ tabId })),
  setTabDefaultFilters: ({ tabId }) => dispatch(setTabDefaultFilters({ tabId })),
  listingsLoadMore: (pclBootstrapData, oldListings, filters) =>
    dispatch(listingsLoadMore(pclBootstrapData, oldListings, filters)),
  listingsFilterCall: (pclnBootstrapData, displayType) =>
    dispatch(listingsFilterCall(pclnBootstrapData, displayType)),
  updateActiveTabId: (activeTabId) => dispatch(updateActiveTabId(activeTabId)),
  setOverfilteredStatus: (overfilteredStatus) => dispatch(setOverfilteredStatus(overfilteredStatus)),
  setPhoneBookInfo: (info) => dispatch(setPhoneBookInfo(info)),
  setSelectedFareBrand: ({ selectedFareBrand }) =>
    dispatch(updateSelectedFareBrandFilters({ selectedFareBrand })),
})

const ListingsContentContainer = connect(mapStateToProps, mapDispatchToProps)(ListingsContent)

export { ListingsContentContainer }
